export default __webpack_public_path__ + "static/media/maelstrom.64261015.png";